import { GuidedSellingStepT } from "@swo/storefront";

export function getMaxTreeDepth(step: GuidedSellingStepT, acc: number = 0): number {
  if (step.type === "final") {
    return acc;
  } else {
    return Math.max(...step.choices.map(v => getMaxTreeDepth(v.nextStep, acc + 1)));
  }
}
